export class Form {

    constructor(settings = {}) {
        this.settings = settings;
        this.tyPopup = $('.js-ty-popup');
        this.tyPopupClose = $('.js-ty-popup__close');
    }

    init() {
        this.contactForm();
        this.tyPopupCloseEvent();
    }

    contactForm() {
        const self = this;

        $("#contact").submit(function(e) {
            e.preventDefault();
            $.ajax({
                type: "POST",
                url: "mailer.php",
                dataType: 'json',
                data: $(this).serialize(),
                success: function (data, text) {

                    if(data.status === 'failed') {
                        // console.log("Failed!");
                        // console.log(data.message);
                        $('.js-error').html(data.message + data.errors);
                    } else {
                        console.log("Success!");
                        $('.js-error').html('');
                        $(this).find("input").val("");
                        $("#contact").trigger("reset");
                        // console.log(JSON.stringify(data)); //alerted the return object
                        self.tyPopupOpenEvent();
                    }
                },
                error: function (request, status, error) {
                    // console.log("Error!");
                    // console.log(request.responseText);
                    $('.js-error').html(request.responseText);
                }
            });
            return false;
        });

    }

    tyPopupOpenEvent() {
        this.tyPopup.aClass('', 'is-visible');
        $('body').aClass('', 'noscroll');
    }

    tyPopupCloseEvent() {
        const self = this;
        this.tyPopupClose.on('click touchstart', (ev) => {
            ev.preventDefault();
            $('body').aClass('noscroll', '');
            self.tyPopup.aClass('is-visible', '');
        });
    }
}



// WEBPACK FOOTER //
// ./static/js/components/Form.js